<p-breadcrumb class="max-w-full pl-6" [home]="home" [model]="breadcrumbMenuItems()" [style]="{'background-color':'#DCE0DB', 'padding': '0px'}"></p-breadcrumb>
